module.exports = __webpack_public_path__ + "static/img/img45.2ae22b1a.png";